import React from 'react';

import { TaxonomyFilterInput } from '../../types/apiTypes';

export const filterHooks = {
  useFilterEmptyFilters() {
    return React.useCallback(
      (filters: TaxonomyFilterInput[] | null): TaxonomyFilterInput[] | null => {
        const notEmptyFilters = filters?.filter(x => x.terms.length);
        return notEmptyFilters?.length ? notEmptyFilters : null;
      }, [],
    );
  },
};
